import find from 'lodash/find';
import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Switch from 'react-switch';
import '../css/Warehouse.css';

class ListModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: props.permission,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ permission: nextProps.permission });
  }

  changePermission = (check, event, id) => {
    const { handleChangePermission } = this.props;
    const { permission } = this.state;
    const moduleId = parseInt(id.split('.')[2], 10);
    const permissionName = id.split('.')[1];
    const module = find(permission, { module_id: moduleId });
    const modulePermission = module.permission;
    if (check) {
      modulePermission.push(permissionName);
    } else {
      const index = modulePermission.indexOf(permissionName);
      if (index > -1) {
        modulePermission.splice(index, 1);
      }
    }
    const changedPermission = { ...module, permission: modulePermission };
    handleChangePermission(changedPermission);
  };

  viewPermission = (cell, row) => {
    const checked = this.hasPermission('view', cell);
    return (
      <Switch
        onChange={this.changePermission}
        checked={checked}
        name="handle-permission"
        id={`module_id.view.${row.module_id}`}
      />
    );
  };

  addPermission = (cell, row) => {
    const checked = this.hasPermission('add', cell);
    return (
      <Switch
        onChange={this.changePermission}
        checked={checked}
        name="handle-permission"
        id={`module_id.add.${row.module_id}`}
      />
    );
  };

  updatePermission = (cell, row) => {
    const checked = this.hasPermission('update', cell);
    return (
      <Switch
        onChange={this.changePermission}
        checked={checked}
        name="handle-permission"
        id={`module_id.update.${row.module_id}`}
      />
    );
  };

  deletePermission = (cell, row) => {
    const checked = this.hasPermission('delete', cell);
    return (
      <Switch
        onChange={this.changePermission}
        checked={checked}
        name="handle-permission"
        id={`module_id.delete.${row.module_id}`}
      />
    );
  };

  hasPermission = (permission, listPermissions) => {
    return listPermissions.indexOf(permission) !== -1;
  };

  render() {
    const { permission } = this.state;
    return (
      <div style={{ padding: '15px' }}>
        <BootstrapTable data={permission} hover className="list-partner">
          <TableHeaderColumn dataField="module_id" hidden isKey>
            Module ID
          </TableHeaderColumn>
          <TableHeaderColumn dataField="module_name">
            Module Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="route_path">
            Route Path
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="permission"
            dataFormat={this.viewPermission}
            headerAlign="center"
            dataAlign="center"
          >
            View
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="permission"
            dataFormat={this.addPermission}
            headerAlign="center"
            dataAlign="center"
          >
            Add
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="permission"
            dataFormat={this.updatePermission}
            headerAlign="center"
            dataAlign="center"
          >
            Update
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="permission"
            dataFormat={this.deletePermission}
            headerAlign="center"
            dataAlign="center"
          >
            Delete
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default ListModule;
